<div class="flex flex-row justify-center items-center v-text-primary">
  <img
    src="assets/images/welcome.svg"
    draggable="false"
    class="w-80"
    alt="not available" />
  <div class="pl-8 flex flex-col">
    <h3 class="font-medium text-xl">Feature not available</h3>
    <div class="mb-4 text-lg text-subtle">
      Feature {{ feature()?.displayName }} is not available in your current plan.
    </div>
    <v-button label="Checkout Plans" class="mt-4" (press)="goToPlans()">
    </v-button>
  </div>
</div>
